<div class="modal-header" id="data-maintenance-location-modal-title">
    <h3 class="modal-title" id="modal-title" translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="dataMaintenanceLocationForm">
        <fieldset formArrayName="formChildren">
            <div class="row mb-3">
                <label
                    class="col-3 col-form-label text-start text-md-end"
                    for="txtName1"
                    translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_NAME"
                ></label>
                <div class="col-12 col-md-8">
                    <pace-core-text-input
                        id="txtName1"
                        name="txtName1"
                        [(model)]="model.name1"
                        [parentForm]="formChildren"
                        [ariaLabel]="('NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_NAME' | translate) + '1'"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12 col-md-8 offset-md-3">
                    <pace-core-text-input
                        id="txtName2"
                        name="txtName2"
                        [(model)]="model.name2"
                        [parentForm]="formChildren"
                        [ariaLabel]="('NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_NAME' | translate) + '2'"
                    ></pace-core-text-input>
                </div>
            </div>
            <ng-container *ngIf="isNgmP58">
                <div class="row mb-3">
                    <div class="col-12 col-md-8 offset-md-3">
                        <pace-core-text-input
                            id="txtName3"
                            name="txtName3"
                            [(model)]="model.name3"
                            [parentForm]="formChildren"
                            [ariaLabel]="('NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_NAME' | translate) + '3'"
                        ></pace-core-text-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-12 col-md-8 offset-md-3">
                        <pace-core-text-input
                            id="txtName4"
                            name="txtName4"
                            [(model)]="model.name4"
                            [parentForm]="formChildren"
                            [ariaLabel]="('NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_NAME' | translate) + '4'"
                        ></pace-core-text-input>
                    </div>
                </div>
            </ng-container>
            <div class="row mb-3">
                <label
                    class="col-3 col-form-label text-start text-md-end"
                    for="txtStreet"
                    translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_STREET"
                ></label>
                <div class="col-12 col-md-8">
                    <pace-core-text-input
                        id="txtStreet"
                        name="txtStreet"
                        [(model)]="model.street"
                        [parentForm]="formChildren"
                        [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_STREET' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3">
                <label
                    class="col-3 col-form-label text-start text-md-end"
                    for="txtCity"
                    translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_CITY"
                ></label>
                <div class="col-12 col-md-8">
                    <pace-core-text-input
                        id="txtCity"
                        name="txtCity"
                        [(model)]="model.city"
                        [parentForm]="formChildren"
                        [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_CITY' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3">
                <label
                    class="col-3 col-form-label text-start text-md-end"
                    for="txtPhone"
                    translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_TEL"
                ></label>
                <div class="col-12 col-md-8">
                    <pace-core-text-input
                        id="txtPhone"
                        name="txtPhone"
                        [(model)]="model.phone"
                        [parentForm]="formChildren"
                        [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_TEL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <ng-container *ngIf="!isNgmP58">
                <div class="row mb-3">
                    <label
                        class="col-3 col-form-label text-start text-md-end"
                        for="txtFaxNr1"
                        translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_EMAIL1"
                    ></label>
                    <div class="col-12 col-md-8">
                        <pace-core-text-input
                            id="txtFaxNr1"
                            name="txtFaxNr1"
                            [(model)]="model.faxNr1"
                            [parentForm]="formChildren"
                            [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_EMAIL1' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <label
                        class="col-3 col-form-label text-start text-md-end"
                        for="txtFaxNr2"
                        translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_EMAIL2"
                    ></label>
                    <div class="col-12 col-md-8">
                        <pace-core-text-input
                            id="txtFaxNr2"
                            name="txtFaxNr2"
                            [(model)]="model.faxNr2"
                            [parentForm]="formChildren"
                            [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_EMAIL2' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="isNgmP58">
                <div class="row mb-3">
                    <label
                        class="col-3 col-form-label text-start text-md-end"
                        for="recipients"
                        translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_EMAIL"
                    ></label>
                    <div class="col-12 col-md-8">
                        <pace-recipient-list
                            id="recipients"
                            name="recipients"
                            [model]="model.recipients"
                            [parentForm]="formChildren"
                        ></pace-recipient-list>
                    </div>
                </div>
                <div class="row mb-3">
                    <label
                        class="col-3 col-form-label text-start text-md-end"
                        for="freeText"
                        translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_FREETEXT"
                    ></label>
                    <div class="col-12 col-md-8">
                        <pace-core-text-input
                            id="freeText"
                            name="freeText"
                            [(model)]="model.freeText"
                            [parentForm]="formChildren"
                            [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_FREETEXT' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
            </ng-container>
            <div class="row mb-3">
                <label
                    class="col-3 col-form-label text-start text-md-end"
                    for="txtFunctionalLoc"
                    translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_FUNCLOC"
                ></label>
                <div class="col-12 col-md-8">
                    <pace-core-text-input
                        id="txtFunctionalLoc"
                        name="txtFunctionalLoc"
                        [(model)]="model.functionalLoc"
                        [parentForm]="formChildren"
                        [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_FUNCLOC' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3" *ngIf="isNgmP58">
                <label
                    class="col-3 col-form-label text-start text-md-end"
                    for="txtCustomerPONo"
                    translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_CUSTPO"
                ></label>
                <div class="col-12 col-md-8">
                    <pace-core-text-input
                        id="txtCustomerPONo"
                        name="txtCustomerPONo"
                        [(model)]="model.custPONo"
                        [parentForm]="formChildren"
                        [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_CUSTPO' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3" *ngIf="displayTechnicalIdNum">
                <label
                    class="col-3 col-form-label text-start text-md-end"
                    for="txtTechIdNum"
                    translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_TECHID"
                ></label>
                <div class="col-12 col-md-8">
                    <pace-core-text-input
                        id="txtTechIdNum"
                        name="txtTechIdNum"
                        [(model)]="model.technicalIdNum"
                        [parentForm]="formChildren"
                        [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_TECHID' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3" *ngIf="displayReasonText">
                <label
                    class="col-3 col-form-label text-start text-md-end"
                    for="txtReason"
                    translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_REASON"
                ></label>
                <div class="col-12 col-md-8">
                    <pace-core-text-input
                        id="txtReason"
                        name="txtReason"
                        [(model)]="model.reasonText"
                        [parentForm]="formChildren"
                        [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_REASON' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <button
        *ngIf="!isLoading"
        class="btn btn-primary"
        [disabled]="dataMaintenanceLocationForm.pristine || dataMaintenanceLocationForm.invalid"
        (click)="submit()"
    >
        {{ strings.footer }}
    </button>
    <progressbar type="default" *ngIf="isLoading" [striped]="true" [value]="100">Sending request...</progressbar>
</div>
